export default function masterProductDirective(
  $q,
  vmDataService
) {
  console.log('app.components.admin.vendorManagementAdmin.masterProductUniqueNameValidator created');
  return {
    restrict: 'A',
    require: 'ngModel',
    link: (scope, element, attributes, ngModel) => {
      const masterVendorId = attributes.masterVendorId || -1;
      const masterProductId = attributes.masterProductId || -1;

      ngModel.$asyncValidators.ssMasterProductUniqueName = (modelValue) => {
        const defer = $q.defer();

        vmDataService.validateMasterProductDuplicateName(
          masterVendorId,
          masterProductId,
          modelValue
        ).then((data) => {
          if (data && !data.data.result) {
            defer.resolve();
          } else {
            defer.reject();
          }
        }).catch(defer.reject);
        return defer.promise;
      };
    },
  };
}

masterProductDirective.$inject = [
  '$q',

  'vmDataService',
];
